import {X} from 'lucide-react';

import React, { useState} from 'react';

const MultiSelect = ({ options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOption = (optionValue) => {
    const newValue = value.includes(optionValue)
      ? value.filter(v => v !== optionValue)
      : [...value, optionValue];
    onChange(newValue);
  };

  const removeValue = (optionValue, e) => {
    e.stopPropagation();
    onChange(value.filter(v => v !== optionValue));
  };

  const selectedLabels = options
    .filter(opt => value.includes(opt.value))
    .map(opt => opt.label);

  return (
    <div className="relative">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white cursor-pointer min-h-[38px] flex flex-wrap gap-1 items-center"
      >
        {selectedLabels.length === 0 ? (
          <span className="text-gray-400 text-sm">{placeholder}</span>
        ) : (
          selectedLabels.map(label => (
            <span
              key={label}
              className="inline-flex items-center gap-1 px-2 py-0.5 bg-pink-100 text-pink-700 rounded text-xs"
            >
              {label}
              <X
                size={12}
                onClick={(e) => removeValue(options.find(o => o.label === label).value, e)}
                className="cursor-pointer hover:text-pink-900"
              />
            </span>
          ))
        )}
      </div>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
            {options.map(option => (
              <div
                key={option.value}
                onClick={() => toggleOption(option.value)}
                className={`px-3 py-2 cursor-pointer hover:bg-gray-100 flex items-center gap-2 ${
                  value.includes(option.value) ? 'bg-pink-50' : ''
                }`}
              >
                <input
                  type="checkbox"
                  checked={value.includes(option.value)}
                  onChange={() => {}}
                  className="rounded text-pink-600"
                />
                <span className="text-sm">{option.label}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
// MultiSelect.jsx
export default MultiSelect;
